import { Component } from 'react';
import styled from 'styled-components';
import ReactModal from 'react-modal';
import { Scrollbars } from 'react-custom-scrollbars';
import { ButtonReset, spacing, size } from 'ui';
import { MdClose } from 'react-icons/md';

ReactModal.defaultStyles = {
  overlay: {
    zIndex: 10,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
  },
  content: {
    position: 'absolute',
    top: spacing(),
    left: '50%',
    transform: 'translateX(-50%)',
    border: 0,
    background: '#fff',
    overflow: 'auto',
    WebkitOverflowScrolling: 'touch',
    borderRadius: 6,
    outline: 'none',
    padding: 0,
    width: spacing(40),
    maxWidth: `calc(100% - ${spacing(2)}`,
    boxShadow: `0 0 20px rgba(0,0,0,.15)`,
  },
};

ReactModal.setAppElement('#app');

const ModalCloseTrigger = styled(ButtonReset)`
  position: absolute;
  top: ${spacing(0.5)};
  right: ${spacing(0.5)};
  z-index: 2;
  font-size: ${size(2)};
  background-color: #fff;
  width: ${spacing(2)};
  height: ${spacing(2)};
  line-height: ${spacing(2)};
  text-align: center;
  border-radius: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin-right: 0;
    display: inline-block;
  }
`;

class Modal extends Component {
  componentDidMount() {
    if (this.props.isOpen) {
      document.documentElement.style.overflowY = 'hidden';
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      document.documentElement.style.overflowY = 'hidden';
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      document.documentElement.style.overflowY = 'auto';
    }
  }

  componentWillUnmount() {
    document.documentElement.style.overflowY = 'auto';
  }

  render() {
    const {
      children,
      isOpen,
      onRequestClose,
      contentLabel,
      tight,
      shallNotBeDismissed,
      full,
      large,
    } = this.props;

    return (
      <ReactModal
        style={{
          content: {
            width: full ? '100%' : large ? '64em' : tight ? '30em' : '40em',
          },
        }}
        isOpen={Boolean(isOpen)}
        onRequestClose={onRequestClose}
        contentLabel={contentLabel}
      >
        {!Boolean(shallNotBeDismissed) && (
          <ModalCloseTrigger onClick={onRequestClose}>
            <MdClose />
          </ModalCloseTrigger>
        )}

        <Scrollbars autoHeight autoHeightMax="calc(100vh - 32px)">
          {children}
        </Scrollbars>
      </ReactModal>
    );
  }
}

export default Modal;
